export default {
  kameraplaner: {
    intro: {
      badge: 'Strumento di pianificazione interattivo – gratuito e non vincolante',
      title: 'Pianificate in anticipo il vostro impianto di telecamere',
      lead:
        'Con il pianificatore di telecamere SSG potete disegnare stanze o superfici, contrassegnare porte, finestre e zone di sorveglianza importanti e testare possibili posizioni delle telecamere. Ottenete una prima valutazione visiva che può poi essere verificata professionalmente da SSG Signaltechnik.',
      noReg: 'Senza registrazione',
      localSave: 'Salvato localmente nel browser',
      noBinding: 'Nessun numero vincolante di telecamere',
      quickTitle: 'Avvia controllo rapido',
      quickDesc:
        'Rispondete in cinque brevi passaggi a domande sul vostro immobile, sulle zone di sorveglianza e sulle funzioni desiderate. Ricevete subito un riepilogo chiaro.',
      quickList: { '0': 'Tipo di immobile e zone da sorvegliare', '1': 'Funzioni desiderate e dati dell’immobile', '2': 'Riassumere il risultato e inviarlo direttamente' },
      quickCta: 'Avvia controllo rapido',
      plannerTitle: 'Pianificate voi stessi la planimetria',
      plannerDesc:
        'Disegnate stanze e pareti, posizionate porte, finestre, ostacoli e telecamere, con coni di visione, analisi di copertura e suggerimenti automatici delle posizioni.',
      plannerList: { '0': 'Superficie di disegno con griglia e scala in metri', '1': 'Coni di visione, obiettivi di sorveglianza e zone private', '2': 'Caricamento planimetria, valutazione e stampa' },
      plannerCta: 'Pianificate voi stessi la planimetria',
      savedTitle: 'C’è una pianificazione salvata',
      savedDesc: 'È stata salvata automaticamente in locale e può essere ripresa.',
      resume: 'Riprendi ultima pianificazione',
    },
    quick: {
      steps: { '0': 'Tipo di immobile', '1': 'Zone', '2': 'Funzioni', '3': 'Dati dell’immobile', '4': 'Risultato' },
      back: 'Torna alla panoramica',
      title: 'Controllo rapido',
      subtitle: 'Cinque brevi passaggi; dopo ricevete un riepilogo chiaro della vostra pianificazione preliminare.',
      stepOf: 'Passaggio {{current}} di {{total}}',
      objectQuestion: 'Quale tipo di immobile fa per voi?',
      chooseOne: 'Selezionate un’opzione.',
      areasQuestion: 'Quali zone devono essere sorvegliate?',
      multiSelect: 'Selezione multipla possibile.',
      featuresTitle: 'Funzioni desiderate',
      dataTitle: 'Dati dell’immobile',
      dataOptional: 'Tutti i dati sono facoltativi e possono essere saltati.',
      areaSize: 'Superficie totale approssimativa (m²)',
      roomCount: 'Numero di stanze o zone',
      inOut: 'Interno, esterno o entrambi?',
      inside: 'Interno',
      outside: 'Esterno',
      both: 'Entrambi',
      maxDistance: 'Massima distanza di sorveglianza stimata',
      pleaseSelect: 'Seleziona',
      distanceUpTo5: 'Fino a 5 metri',
      distance5to10: 'Da 5 a 10 metri',
      distance10to20: 'Da 10 a 20 metri',
      distanceOver20: 'Oltre 20 metri',
      internet: 'Connessione internet disponibile?',
      network: 'Cablaggio di rete disponibile?',
      power: 'Corrente nel punto di montaggio?',
      yes: 'Sì',
      no: 'No',
      unknown: 'Sconosciuto',
      recordingDuration: 'Durata di registrazione desiderata',
      installType: 'Impianto nuovo o esistente?',
      newSystem: 'Impianto nuovo',
      existingSystem: 'Impianto esistente',
      existingManufacturer: 'Produttore e modello dell’impianto esistente (se noto)',
      requirements: 'Requisiti particolari',
      requirementsPlaceholder: 'Ad esempio condizioni di luce particolari, tutela monumentale, prescrizioni speciali...',
      chars: '{{current}}/500 caratteri',
      ssgCarePre: 'Sono inoltre interessato a',
      ssgCarePost: '– manutenzione e assistenza personale dell’impianto.',
      overviewTitle: 'La vostra pianificazione preliminare in sintesi',
      amberNote:
        'Sulla base dei vostri dati possono essere adatte diverse posizioni o tipi di telecamera. Per una raccomandazione affidabile vanno verificati angoli di visione, altezza di montaggio, illuminazione e ostacoli presenti.',
      planFloorplan: 'Pianifica inoltre la planimetria',
      sendToSsg: 'Invia dati a SSG',
      editResult: 'Modifica risultato',
      backBtn: 'Indietro',
      next: 'Avanti',
      summary: {
        objectType: 'Tipo di immobile',
        areas: 'Zone di sorveglianza',
        features: 'Funzioni desiderate',
        areaSize: 'Superficie totale approssimativa',
        roomCount: 'Stanze / zone',
        inOut: 'Zona',
        maxDistance: 'Massima distanza di sorveglianza',
        internet: 'Connessione internet',
        network: 'Cablaggio di rete',
        power: 'Corrente nel punto di montaggio',
        recordingDuration: 'Durata di registrazione',
        installType: 'Impianto',
        existingSystem: 'Impianto esistente',
        requirements: 'Requisiti particolari',
        ssgCare: 'Assistenza SSG Care',
      },
      values: {
        notSpecified: 'Non specificato',
        inside: 'Interno',
        outside: 'Esterno',
        inOut: 'Interno ed esterno',
        present: 'Disponibile',
        notPresent: 'Non disponibile',
        unknown: 'Sconosciuto',
        unclear: 'ancora da chiarire',
        newSystem: 'Impianto nuovo',
        existing: 'Impianto esistente',
        desired: 'Desiderato',
      },
    },
    topbar: {
      projectName: 'Nome progetto',
      undo: 'Annulla',
      undoTip: 'Annulla (Ctrl+Z)',
      redo: 'Ripeti',
      redoTip: 'Ripeti (Ctrl+Y)',
      save: 'Salva temporaneamente',
      saved: 'Salvato',
      saveTip: 'Salva temporaneamente',
      reset: 'Ripristina',
      resetTip: 'Ripristina pianificatore',
      help: 'Aiuto',
      helpTip: 'Riapri l’introduzione',
      evaluate: 'Valuta pianificazione',
      evaluateTip: 'Valuta pianificazione',
    },
    tools: {
      select: { label: 'Seleziona', hint: 'Sposta, ridimensiona, ruota elementi. Trascina spazio vuoto = sposta.' },
      erase: { label: 'Elimina', hint: 'Elimina l’elemento con un clic.' },
      room: { label: 'Stanza rettangolare', hint: 'Disegna una stanza o superficie trascinando – le misure sono mostrate in tempo reale.' },
      polygon: { label: 'Superficie libera', hint: 'Disegna una superficie libera a mano: tieni premuto e traccia la forma.' },
      wall: { label: 'Parete', hint: 'Disegna una parete trascinando – limita le linee di visione.' },
      door: { label: 'Porta', hint: 'Posiziona una porta su una parete – poi sposta o ruota direttamente.' },
      window: { label: 'Finestra', hint: 'Posiziona una finestra su una parete – poi sposta o ruota direttamente.' },
      obstacle: { label: 'Ostacolo', hint: 'Disegna una colonna, scaffale, parete divisoria o blocco di mobili.' },
      watch: { label: 'Obiettivo di sorveglianza', hint: 'Contrassegna una zona importante da catturare.' },
      privacy: { label: 'Zona privata', hint: 'Contrassegna una zona che non deve essere catturata.' },
      camera: { label: 'Telecamera', hint: 'Posiziona una telecamera con un clic. A destra si apre il menu dei modelli – il modello adatto è già consigliato.' },
      text: { label: 'Testo', hint: 'Aggiungi nomi di stanze o etichette.' },
    },
    editor: {
      tools: 'Strumenti',
      autoSuggest: 'Suggerimenti automatici',
      analysis: 'Analisi di copertura',
      properties: 'Proprietà',
      backToIntro: 'Torna alla panoramica del pianificatore di telecamere',
      resetTitle: 'Ripristinare il pianificatore?',
      resetText: 'Tutti gli elementi disegnati, le telecamere e la planimetria caricata verranno eliminati definitivamente. La pianificazione salvata verrà rimossa.',
      cancel: 'Annulla',
      confirmReset: 'Sì, ripristina',
      close: 'Chiudi',
      openTools: 'Apri strumenti',
      openAnalysis: 'Apri analisi',
      snap: 'Attiva/disattiva aggancio alla griglia',
      zoomIn: 'Ingrandisci',
      zoomOut: 'Riduci',
      fit: 'Centra planimetria',
      closeHints: 'Chiudi avvisi',
    },
    canvas: {
      areaLabel: 'Superficie di disegno della planimetria',
      calibHint: 'Impostate una distanza per il ridimensionamento',
      locked: 'bloccato',
      scale: 'Scala: ca. {{px}} px/m · Griglia {{step}} m',
      calibNotice: 'Fate clic su due punti della planimetria di cui conoscete la distanza.',
    },
    props: {
      edit: 'Modifica proprietà',
      delete: 'Elimina',
      cameraModel: 'Modello di telecamera (dispositivo reale)',
      nameNumber: 'Nome / numero',
      cameraCategory: 'Categoria telecamera',
      modelAssigned: 'Il modello "{{series}}" è assegnato.',
      planningValues: 'Questi sono valori di pianificazione, non dati tecnici di un prodotto reale.',
      visibility: 'Visibilità',
      recognition: 'Riconoscimento',
      detail: 'Dettaglio',
      rotation: 'Orientamento (°)',
      fov: 'Angolo di visione (°)',
      range: 'Portata (m)',
      posX: 'Posizione X (m)',
      posY: 'Posizione Y (m)',
      mountHeight: 'Altezza di montaggio (m)',
      indoor: 'Interno',
      outdoor: 'Esterno',
      usage: 'Ambito di utilizzo',
      dayNight: 'Giorno / notte',
      target: 'Obiettivo di sorveglianza desiderato',
      noneAssigned: 'Nessuno assegnato',
      targetArea: 'Zona obiettivo',
      remark: 'Nota',
      remarkPlaceholder: 'es. note su montaggio o ambiente...',
      coneNote: 'Il cono di visione è una rappresentazione di pianificazione. La qualità reale dell’immagine dipende da modello, obiettivo, distanza, altezza di montaggio, luce e ostacoli sul posto.',
      roomLabel: 'Denominazione stanza',
      length: 'Lunghezza (m)',
      width: 'Larghezza (m)',
      area: 'Superficie: ca. {{area}} m²',
      designation: 'Denominazione',
      points: '{{count}} punti; spostate i punti direttamente sulla superficie di disegno.',
      wallThickness: 'Spessore parete (m)',
      wallLength: 'Lunghezza: ca. {{length}} m',
      wallNote: 'Le pareti piene limitano le linee di visione nel pianificatore.',
      obstacleKind: 'Tipo di ostacolo',
      shape: 'Forma',
      rect: 'Rettangolo',
      circle: 'Cerchio',
      caption: 'Etichetta',
      diameter: 'Diametro (m)',
      depth: 'Profondità (m)',
      goalKind: 'Tipo di obiettivo',
      priority: 'Priorità',
      goal: 'Obiettivo desiderato',
      coverageNote: 'La copertura è valutata a colori (verde / giallo / rosso). Per gli obiettivi di dettaglio valgono requisiti più severi.',
      zoneKind: 'Tipo di zona',
      privacyNote: 'Se un cono di visione si sovrappone a questa zona, nell’analisi compare un avviso.',
      textContent: 'Contenuto del testo',
      duplicate: 'Duplica',
      deleteElement: 'Elimina elemento',
      projectData: 'Dati del progetto',
      noElement: 'Nessun elemento selezionato',
      projectName: 'Nome progetto',
      objectType: 'Tipo di immobile',
      objectTypePlaceholder: 'es. casa unifamiliare',
      projectDescription: 'Descrizione del progetto',
      projectDescriptionPlaceholder: 'Particolarità, desideri o condizioni generali...',
      maxChars: 'Massimo 500 caratteri',
      cameraForNew: 'Modello di telecamera per nuove telecamere',
      cameraForNewDesc: 'Selezionate sotto il modello Safire desiderato; il menu a discesa si apre automaticamente. Le nuove telecamere vengono posizionate con queste impostazioni.',
      recommendedFor: 'Consigliato per la vostra superficie:',
      orGeneric: 'o categoria generica',
      tips: 'Suggerimenti',
      tip1: 'Trascinare spazio vuoto con lo strumento di selezione = sposta superficie. Rotellina = zoom.',
      tip2: 'Ctrl+Z = annulla, Ctrl+Y = ripeti, Canc = elimina elemento.',
      tip3: 'L’aggancio alla griglia si attiva/disattiva nelle opzioni di visualizzazione.',
      suggestPositions: 'Suggerisci automaticamente le posizioni delle telecamere',
      doorSwing: 'Direzione di apertura',
      left: 'Sinistra',
      right: 'Destra',
      none: 'Nessuna',
      attached: 'Posizionata su una parete; trascinate lungo la parete per spostarla. Ruotando l’elemento si libera.',
      detached: 'Posizionata libera; spostatela e ruotatela liberamente.',
      doorNote: 'Materiale, vetratura e stato di apertura vanno verificati sul posto.',
    },
    result: {
      edit: 'Modifica pianificazione',
      print: 'Stampa riepilogo',
      savePdf: 'Salva come PDF',
      send: 'Invia pianificazione a SSG',
      eyebrow: 'Valutazione',
      title: 'La vostra pianificazione preliminare in sintesi',
      disclaimer:
        'Questa valutazione è una pianificazione preliminare non vincolante. Una raccomandazione definitiva verrà fatta solo dopo la verifica delle condizioni locali e la scelta della tecnologia concreta.',
      project: 'Progetto',
      objectType: 'Tipo di immobile:',
      uploadPresent: 'Caricamento planimetria disponibile:',
      scaled: 'ridimensionato',
      refDistance: 'm di distanza di riferimento',
      notScaled: 'non ancora ridimensionato',
      createdAt: 'Creato il',
      floorplan: 'Planimetria disegnata',
      noElements: 'Nessun elemento presente nella planimetria.',
      stats: { rooms: 'Stanze e zone', walls: 'Pareti', doors: 'Porte', windows: 'Finestre', obstacles: 'Ostacoli', cameras: 'Telecamere', zones: 'Zone obiettivo', privacy: 'Zone private' },
      zonesTitle: 'Obiettivi di sorveglianza e priorità',
      noZones: 'Nessun obiettivo di sorveglianza contrassegnato.',
      priorityLabel: 'Priorità',
      goalLabel: 'Obiettivo',
      goalOverview: 'Panoramica',
      goalDetail: 'Dettaglio',
      goalObservation: 'Osservazione',
      coverage: 'copertura geometrica',
      camerasTitle: 'Posizioni e tipi di telecamera',
      noCameras: 'Nessuna telecamera ancora posizionata.',
      modelLabel: 'Modello',
      fovLabel: 'Angolo di visione',
      visibilityLabel: 'Visibilità ca.',
      recognitionLabel: 'Riconoscimento ca.',
      detailLabel: 'Dettaglio ca.',
      positionLabel: 'Posizione',
      rotationLabel: 'Orientamento',
      rangeLabel: 'Portata ca.',
      mountLabel: 'Altezza di montaggio',
      indoor: 'Interno',
      outdoor: 'Esterno',
      day: 'Giorno',
      night: 'Notte',
      dayNight: 'Giorno e notte',
      target: 'Obiettivo',
      assigned: 'Assegnato',
      modelNote:
        'I modelli Safire selezionati si basano su valori di scheda tecnica; visibilità/riconoscimento/dettaglio sono valori di pianificazione calcolati (EN 62676-4). Senza modello i valori sono generici, non dati tecnici di un prodotto reale.',
      blindTitle: 'Possibili angoli ciechi e punti aperti',
      uncovered: 'Zone non sufficientemente coperte:',
      privacyOverlaps: 'Sovrapposizioni con zone private:',
      checkPrivacy: 'Verificate posizione, orientamento o mascheramento.',
      missingTitle: 'Dati importanti mancanti',
      quickTitle: 'Funzioni desiderate e dati dell’immobile',
      areasLabel: 'Zone:',
      featuresLabel: 'Funzioni:',
      areaLabel: 'Superficie:',
      recordingLabel: 'Registrazione:',
      internetLabel: 'Internet:',
      powerLabel: 'Corrente:',
      careInterest: 'Interesse per l’assistenza SSG Care',
      finalNote: 'La pianificazione sarà verificata professionalmente da SSG Signaltechnik. Altezza di montaggio, illuminazione, angoli e condizioni del posto determinano l’esecuzione finale.',
      sendBottom: 'Invia pianificazione a SSG Signaltechnik',
      consult: 'Richiedi consulenza personale',
      good: 'Ben coperto',
      partial: 'Parzialmente coperto',
      insufficient: 'Non sufficiente',
    },
    send: {
      back: 'Indietro',
      title: 'Invia pianificazione a SSG Signaltechnik',
      lead:
        'I vostri dati di pianificazione (planimetria, telecamere, angoli di visione, obiettivi di sorveglianza, zone private e risultato dell’analisi) vengono trasmessi insieme ai vostri dati di contatto. I dati di contatto servono solo ora; la pianificazione resta localmente sul vostro dispositivo.',
      dataTitle: 'Dati di pianificazione trasmessi',
      floorplan: 'Planimetria',
      rooms: 'Stanze/zone',
      walls: 'Pareti',
      doors: 'Porte',
      windows: 'Finestre',
      obstacles: 'Ostacoli',
      cameras: 'Telecamere',
      none: 'nessuna',
      zones: 'Obiettivi di sorveglianza',
      privacy: 'Zone private',
      analysis: 'Analisi',
      good: 'bene',
      partial: 'parziale',
      insufficient: 'non sufficientemente coperto',
      upload: 'Caricamento planimetria',
      scaled: 'ridimensionato',
      notScaled: 'non ridimensionato',
      customerType: 'Cliente privato o aziendale *',
      privateCustomer: 'Cliente privato',
      businessCustomer: 'Cliente aziendale',
      name: 'Nome e cognome *',
      company: 'Azienda (facoltativo)',
      phone: 'Numero di telefono',
      email: 'Indirizzo email *',
      projectAddress: 'Indirizzo del progetto',
      projectAddressPlaceholder: 'Via, CAP, città',
      contactPref: 'Metodo di contatto preferito',
      any: 'Indifferente',
      byPhone: 'Telefono',
      byEmail: 'Email',
      callbackTime: 'Orario preferito per la richiamata',
      noCallback: 'Nessuna richiamata desiderata',
      morning: 'Mattina',
      afternoon: 'Pomeriggio',
      evening: 'Sera',
      systemStatus: 'Impianto nuovo o esistente',
      newSystem: 'Impianto nuovo',
      existingSystem: 'Impianto esistente',
      unsure: 'Ancora indeciso',
      existingManufacturer: 'Produttore di un impianto esistente (se noto)',
      existingManufacturerPlaceholder: 'es. Hikvision, Safire...',
      careInterest: 'Interesse per SSG Care',
      careYes: 'Sì, informami',
      careNo: 'No',
      careLater: 'Decidere più tardi',
      message: 'Messaggio aggiuntivo',
      messagePlaceholder: 'Aggiunte alla vostra pianificazione...',
      fileUpload: 'Planimetria / foto (facoltativo)',
      fileNote: 'Nota: i caricamenti di file sono trattati come "Uncollectable"; i dati di pianificazione vengono trasmessi come testo.',
      privacyConsent:
        'Ho letto l’informativa sulla privacy e acconsento al trattamento dei miei dati per la gestione di questa richiesta. I dati di pianificazione vengono usati esclusivamente per la gestione. *',
      privacyLink: 'Informativa sulla privacy',
      error: 'Si è verificato un errore. Riprovate più tardi.',
      networkError: 'Errore di rete. Controllate la connessione e riprovate.',
      successTitle: 'Grazie per la vostra pianificazione.',
      successText: 'SSG Signaltechnik verificherà i vostri dati e vi contatterà personalmente.',
      sending: 'Invio in corso...',
      submit: 'Invia pianificazione a SSG',
      backToResult: 'Torna alla valutazione',
    },
    tour: {
      stepOf: 'Passaggio {{current}} di {{total}}',
      skip: 'Salta',
      back: 'Indietro',
      next: 'Avanti',
      finish: 'Iniziamo',
      dialogLabel: 'Introduzione al pianificatore di telecamere',
      steps: {
        '0': { title: 'Benvenuti nel pianificatore di telecamere SSG', text: 'Disegnate la vostra stanza o caricate una planimetria.' },
        '1': { title: 'Contrassegnare le zone', text: 'Contrassegnate porte, finestre e zone importanti.' },
        '2': { title: 'Posizionare le telecamere', text: 'Posizionate le telecamere o fatevi suggerire le posizioni.' },
        '3': { title: 'Controllare i campi di visione', text: 'Controllate i campi di visione e i possibili angoli ciechi.' },
        '4': { title: 'Inviare la pianificazione', text: 'Inviate la pianificazione preliminare a SSG Signaltechnik.' },
      },
    },
    analysis: {
      title: 'Analisi di copertura',
      suggest: 'Suggerisci posizioni',
      suggestTip: 'Suggerisci posizioni delle telecamere',
      cameras: 'Telecamere',
      zones: 'Zone obiettivo',
      good: 'Ben coperto',
      partial: 'Parziale',
      notCovered: 'Non coperto',
      privacyConflict: 'Conflitto zona privata',
      areaCoverage: 'Copertura geometrica della superficie',
      areaNote: 'Copertura rappresentata geometricamente; nessuna indicazione sulla qualità reale di immagine o riconoscimento.',
      legend: 'Legenda',
      legendFov: 'Campo di visione telecamera',
      legendDetail: 'Riconoscimento di dettaglio nitido (tratteggiato)',
      legendGood: 'Obiettivo ben coperto',
      legendPartial: 'Obiettivo parzialmente coperto',
      legendBad: 'Obiettivo insufficiente',
      legendPrivacy: 'Zona privata / esclusa',
      note: 'La valutazione a colori è un orientamento geometrico. Un angolo di visione ampio non significa automaticamente riconoscimento di dettaglio sufficiente; vanno verificati distanza, risoluzione e altezza di montaggio.',
    },
    upload: {
      title: 'Carica planimetria',
      desc: 'Facoltativo: caricate una planimetria esistente (JPG, PNG o WebP) come sfondo. Poi contrassegnate una distanza nota e inserite la sua lunghezza affinché il pianificatore ridimensioni correttamente.',
      choose: 'Seleziona planimetria',
      chooseOther: 'Scegli un’altra immagine',
      remove: 'Rimuovi',
      calibPrompt: 'Ora fate clic sul punto A e sul punto B della planimetria nella superficie di disegno.',
      startCalib: 'Avvia ridimensionamento',
      scaled: 'Ridimensionato: {{cm}} cm per pixel · Distanza {{m}} m',
      lengthPlaceholder: 'Lunghezza in metri',
      apply: 'Applica',
      opacity: 'Opacità {{pct}} %',
      lock: 'Blocca sfondo (impedisce spostamenti accidentali)',
      moveHint: 'Per spostare: trascinate un punto vuoto dell’immagine con lo strumento di selezione (se non bloccato).',
      privacyNote: 'Planimetrie e foto dell’immobile possono contenere informazioni sensibili. Caricate solo file necessari per gestire la richiesta.',
      onlyImages: 'Selezionate solo immagini JPG, PNG o WebP.',
      tooLarge: 'Il file è troppo grande. Selezionate un’immagine sotto 8 MB.',
      readError: 'Impossibile leggere il file.',
      validLength: 'Inserite una lunghezza valida in metri.',
      tooClose: 'I punti contrassegnati sono troppo vicini.',
    },
    picker: {
      generic: 'Seleziona categoria generica',
      genericOption: 'Categoria generica (senza modello)',
      recommended: 'Consigliato',
      recommendation: 'Raccomandazione per la vostra superficie',
      fovLabel: 'Angolo di visione',
      detailFrom: 'Dettaglio da ca. {{detail}} m · Riconoscimento ca. {{recognition}} m',
      hFov: 'Angolo di visione orizzontale',
      vFov: 'Angolo di visione verticale',
      resolution: 'Risoluzione',
      lens: 'Obiettivo',
      irRange: 'Portata IR',
      ipClass: 'Classe di protezione',
      audio: 'Audio',
      dayNight: 'Giorno / notte',
      datenblatt: 'Scheda tecnica',
      planungswert: 'Valore di pianificazione',
      doriNote:
        'Visibilità/riconoscimento/dettaglio: valori di pianificazione calcolati secondo EN 62676-4 (densità di pixel). La qualità reale dell’immagine dipende da modello, obiettivo, altezza di montaggio, luce e ostacoli sul posto.',
      groups: { standard: 'Standard / interno ed esterno', outdoor: 'Esterno', panorama180: 'Panorama', ptz: 'Panoramica / zoom' },
    },
    quickswitch: {
      title: 'Cambia modello di telecamera',
      subtitle: 'Cambia direttamente la variante',
      active: 'Attivo',
      recommended: 'Consigliato',
      note: 'Impostate orientamento, portata e altezza di montaggio nel pannello proprietà a destra.',
      close: 'Chiudi selezione modello',
    },
    elementTypes: {
      room: 'Stanza / zona',
      polygon: 'Zona libera',
      wall: 'Parete',
      door: 'Porta',
      window: 'Finestra',
      obstacle: 'Ostacolo',
      watchzone: 'Obiettivo di sorveglianza',
      privacy: 'Zona privata / eccezione',
      camera: 'Telecamera',
      text: 'Testo',
    },
    defaults: { room: 'Stanza', watchzone: 'Zona obiettivo', text: 'Nome stanza' },
    defaultProject: 'La mia pianificazione telecamere',
    quickProject: 'Pianificazione telecamere (controllo rapido)',
    options: {
      objectTypes: {
        Einfamilienhaus: 'Casa unifamiliare',
        Mehrfamilienhaus: 'Condominio',
        Wohnung: 'Appartamento',
        'Ladengeschäft': 'Negozio',
        'Büro oder Praxis': 'Ufficio o studio',
        Gastronomie: 'Ristorazione',
        'Lager oder Logistik': 'Magazzino o logistica',
        Werkstatt: 'Officina',
        'Parkplatz oder Außenfläche': 'Parcheggio o area esterna',
        Baustelle: 'Cantiere',
        Sonstiges: 'Altro',
      },
      areas: {
        Haupteingang: 'Ingresso principale',
        Nebeneingang: 'Ingresso secondario',
        Fenster: 'Finestra',
        Einfahrt: 'Accesso carrabile',
        Garage: 'Garage',
        'Garten oder Terrasse': 'Giardino o terrazza',
        Kasse: 'Cassa',
        Verkaufsfläche: 'Area vendita',
        Lager: 'Magazzino',
        Lieferzone: 'Zona consegna',
        Parkplatz: 'Parcheggio',
        'Büro oder Innenraum': 'Ufficio o interno',
        'Gesamte Außenfläche': 'Intera area esterna',
        'Sonstiger Bereich': 'Altra zona',
      },
      features: {
        'Live-Ansicht': 'Visualizzazione live',
        'lokale Aufzeichnung': 'Registrazione locale',
        'Smartphone-Zugriff': 'Accesso da smartphone',
        'Wiedergabe gespeicherter Aufnahmen': 'Riproduzione delle registrazioni salvate',
        Ereignisbenachrichtigungen: 'Notifiche di eventi',
        'gute Sicht bei Dunkelheit': 'Buona visibilità al buio',
        'Übersicht über eine große Fläche': 'Panoramica di una grande superficie',
        'Erkennung wichtiger Details': 'Riconoscimento di dettagli importanti',
        'mehrere Benutzer': 'Più utenti',
        'mehrere Standorte': 'Più sedi',
        'vorhandene Anlage erweitern': 'Ampliare l’impianto esistente',
        'SSG-Care-Betreuung': 'Assistenza SSG Care',
      },
      recordingDurations: {
        'Bis 7 Tage': 'Fino a 7 giorni',
        'Bis 14 Tage': 'Fino a 14 giorni',
        'Bis 30 Tage': 'Fino a 30 giorni',
        'Mehr als 30 Tage': 'Più di 30 giorni',
        'noch unklar': 'ancora da chiarire',
      },
      roomNames: {
        Eingang: 'Ingresso',
        Flur: 'Corridoio',
        Wohnzimmer: 'Soggiorno',
        'Büro': 'Ufficio',
        Verkaufsfläche: 'Area vendita',
        Kasse: 'Cassa',
        Lager: 'Magazzino',
        Werkstatt: 'Officina',
        Parkplatz: 'Parcheggio',
        Außenbereich: 'Area esterna',
      },
      obstacles: {
        saeule: 'Colonna',
        regal: 'Scaffale',
        trennwand: 'Parete divisoria alta',
        moebel: 'Blocco di mobili',
        fahrzeug: 'Posto auto',
        eigen: 'Ostacolo con nome',
      },
      watchKinds: {
        ueberblick: 'Sorvegliare completamente l’area',
        eingang: 'Osservare l’ingresso',
        tuer: 'Sorvegliare la porta',
        fenster: 'Sorvegliare la finestra',
        kasse: 'Catturare cassa o punto sensibile',
        zufahrt: 'Osservare l’accesso',
        kennzeichen: 'Controllare l’area targhe',
        flaeche: 'Panoramica di una superficie',
        details: 'Riconoscere dettagli importanti',
        individuell: 'Zona individuale',
      },
      watchPriorities: { normal: 'Normale', wichtig: 'Importante', kritisch: 'Critico' },
      watchGoals: { uebersicht: 'Panoramica', beobachtung: 'Osservazione', detail: 'Dettaglio' },
      privacyKinds: {
        privat: 'Zona privata',
        nachbar: 'Proprietà del vicino',
        oeffentlich: 'Marciapiede o strada pubblica',
        mitarbeiter: 'Area dipendenti',
        ausgeschlossen: 'Zona da non riprendere',
      },
      categories: {
        standard: { label: 'Telecamera standard', hint: 'Versatile per interni ed esterni' },
        wide: { label: 'Telecamera grandangolare', hint: 'Ampia panoramica a breve/media distanza' },
        varifocal: { label: 'Telecamera con angolo variabile', hint: 'L’angolo viene impostato sul posto' },
        panorama180: { label: 'Telecamera panoramica 180°', hint: 'Ripresa molto ampia, riconoscimento di dettaglio limitato' },
        fisheye360: { label: 'Telecamera 360° / fisheye', hint: 'Vista a tutto tondo, immagine corretta elettronicamente' },
        ptz: { label: 'Telecamera PTZ', hint: 'Telecamera pan/tilt/zoom per superfici più grandi' },
        indoor: { label: 'Telecamera interna', hint: 'Ottimizzata per interni' },
        outdoor: { label: 'Telecamera esterna', hint: 'Versione resistente alle intemperie per esterni' },
      },
      dayNight: { tag: 'Giorno', nacht: 'Notte', beides: 'Giorno e notte' },
    },
    models: {
      'safire-turret-i1-4mp': { ai: 'Classificazione persone e veicoli (AI)', note: 'Telecamera turret versatile con ampio angolo di visione: un buon standard per interni ed esterni.' },
      'safire-turret-e1-4mp': { ai: 'Classificazione persone e veicoli (AI)', note: 'Modello base conveniente della serie E1 con risoluzione solida.' },
      'safire-turret-b1-4mp': { ai: '', note: 'Turret economy robusta con corpo resistente agli urti (IK10).' },
      'safire-dome-i2-8mp': { ai: 'Classificazione persone e veicoli (AI)', note: 'Alta risoluzione 8 MP: più dettaglio nella stessa inquadratura.' },
      'safire-bullet-4mp': { ai: 'Classificazione persone e veicoli (AI)', note: 'Classico design bullet per montaggio esterno. Angolo di visione come valore di pianificazione basato sulla serie.' },
      'safire-turret-nightcolor-4mp': { ai: 'Immagine a colori al buio (NightColor X)', note: 'Fornisce un’immagine a colori anche in scarsa luce: ideale per situazioni notturne critiche. Angolo di visione come valore di pianificazione.' },
      'safire-turret-duallight-4mp': { ai: 'Classificazione persone e veicoli (AI)', note: 'DualLight con LED IR e a luce bianca (30 m ciascuno): flessibile di notte. Angolo di visione come valore di pianificazione.' },
      'safire-panorama-180-8mp': { ai: 'Vista a 180° con altoparlante e microfono', note: 'Riprende un’area molto ampia con una telecamera; il riconoscimento di dettaglio a distanza è limitato.' },
      'safire-miniptz-4mp': { ai: 'Autotracking, classificazione persone e veicoli', note: 'Telecamera PTZ con autotracking. Angolo di visione come valore di pianificazione (posizione finale grandangolare).' },
      'safire-ptz-15x-2mp': { ai: 'Autotracking, tracking auto e veicoli', note: 'Grande portata grazie allo zoom 15× e IR da 200 m. Angolo di visione come valore di pianificazione (posizione finale grandangolare).' },
    },
    disclaimer: {
      general:
        'Il pianificatore di telecamere fornisce una pianificazione preliminare non vincolante. L’inquadratura reale e la posizione adatta dipendono, tra l’altro, da modello, obiettivo, distanza, altezza di montaggio, illuminazione, ostacoli e condizioni del posto.',
      result:
        'Questa valutazione è una pianificazione preliminare non vincolante. Una raccomandazione definitiva verrà fatta solo dopo la verifica delle condizioni locali e la scelta della tecnologia concreta.',
      upload: 'Planimetrie e foto dell’immobile possono contenere informazioni sensibili. Caricate solo file necessari per gestire la richiesta.',
      sichtfeld: 'Porte e finestre possono influenzare le linee di visione. Materiale, vetratura, stato di apertura e riflessi di luce vanno verificati sul posto.',
      datenschutz:
        'Per requisiti come riconoscimento facciale, identificazione di persone o riconoscimento targhe è necessaria una verifica tecnica e sulla protezione dei dati.',
    },
    hints: {
      '0':
        'Sulla base dei vostri dati possono essere adatte diverse posizioni o tipi di telecamera. Per una raccomandazione affidabile vanno verificati angoli di visione, altezza di montaggio, illuminazione e ostacoli presenti.',
      '1':
        'Un angolo di visione ampio non significa automaticamente riconoscimento di dettaglio sufficiente. Distanza, risoluzione, angolo, altezza di montaggio e obiettivo influenzano la qualità reale dell’immagine.',
      '2': 'Altezza di montaggio e condizioni di illuminazione vanno verificate sul posto.',
    },
    recommend: {
      noArea: 'Raccomandazione standard finché non è stata disegnata alcuna superficie. Disegnate la vostra stanza e la raccomandazione si adeguerà.',
      veryLarge: 'Superficie molto grande (ca. {{area}} m²): PTZ con zoom e grande portata per ampie distanze.',
      large: 'Superficie grande (ca. {{area}} m²): robusto design bullet per esterni.',
      medium: 'Superficie medio-grande (ca. {{area}} m²): 8 MP per più dettaglio in larghezza.',
      compact: 'Superficie compatta (ca. {{area}} m²): un ampio angolo di visione copre bene la stanza.',
    },
    analysisDynamic: {
      missingNoCameras: 'Nessuna telecamera ancora posizionata.',
      missingNoRooms: 'Nessuna stanza o superficie ancora disegnata.',
      missingNoWalls: 'Nessuna parete disegnata; i coni di visione non vengono limitati.',
      missingNoZones: 'Nessun obiettivo di sorveglianza contrassegnato.',
      missingNoPrivacy: 'Nessuna zona privata o di esclusione contrassegnata.',
      missingNoInternet: 'Manca l’informazione sulla connessione internet.',
      missingNoPower: 'Manca l’informazione sull’alimentazione elettrica.',
      hintUncovered: 'Zone obiettivo senza copertura sufficiente: verificate le posizioni o pianificate telecamere aggiuntive.',
      hintPartial: 'Alcune zone obiettivo sono solo parzialmente coperte; regolate angolo, posizione o portata.',
      hintDetailRange: 'La portata di dettaglio di "{{name}}" (ca. {{range}} m) probabilmente non basta da sola per stanze grandi; una telecamera aggiuntiva potrebbe essere utile.',
      hintPrivacy: 'Il campo di visione si sovrappone a una zona privata contrassegnata. Vanno verificate posizione, orientamento o mascheramento tecnico.',
      hintMount: 'Altezza di montaggio e condizioni di illuminazione vanno verificate sul posto.',
      hintKennzeichen: 'Necessaria verifica tecnica e sulla protezione dei dati.',
      noteDetailRange:
        'Il riconoscimento di dettaglio probabilmente non è sufficiente per ca. {{distance}} m di distanza; dettaglio max ca. {{identification}} m. Andrebbe verificato un angolo più stretto o un modello con risoluzione maggiore.',
      noteDetailUncertain: 'Il riconoscimento di dettaglio su distanze maggiori è incerto; vanno verificati un angolo più stretto e l’altezza di montaggio.',
      notePartial: 'Questa zona potrebbe essere solo parzialmente coperta.',
      suggestNear: 'L’obiettivo di sorveglianza "{{target}}" è vicino a "{{privacy}}". Posizione e orientamento vanno scelti con cura; è necessaria una verifica sulla protezione dei dati.',
      suggestHeuristic: 'I suggerimenti sono euristici. Ogni telecamera può essere spostata, ruotata, modificata o eliminata liberamente.',
      suggestWide: 'Un angolo di visione ampio non significa riconoscimento di dettaglio sufficiente. Distanza, risoluzione e altezza di montaggio influenzano la qualità dell’immagine.',
      cameraNoteDetail: 'Prima possibile posizione della telecamera; pianificate un angolo più stretto per gli obiettivi di dettaglio.',
      cameraNoteCheck: 'Prima possibile posizione della telecamera; verificate e regolate.',
      cameraSuggestion: 'Suggerimento {{count}}',
      uncoveredPartial: 'parziale',
      uncoveredInsufficient: 'non sufficiente',
      toastNoPositions: 'Nessuna nuova posizione trovata. Aggiungete obiettivi di sorveglianza o stanze.',
      toastSuggested: '{{count}} prima/e possibile/i posizione/i della telecamera suggerita/e.',
    },
  },
};